// Maps window type + config + handing → inventory code and series description
// Based on EBMS codes seen in Crystal Reports shop order

const COLOR_SUFFIX = {
  'White':              'WH',
  'Clay':               'CL',
  'Dk Woodgrain/White': 'DW',
  'Dk Woodgrain/Clay':  'DC',
};

// DH — Double Hung
function dhCode(config, color) {
  const c = COLOR_SUFFIX[color] || 'WH';
  const codes = {
    'Single': { code: `DH-${c}`,    series: `Double Hung (${color})` },
    'Twin':   { code: `DHT-${c}`,   series: `Twin Double Hung (${color})` },
    'Triple': { code: `DHTR-${c}`,  series: `Triple Double Hung (${color})` },
    'Quad':   { code: `DHQ-${c}`,   series: `Quad Double Hung (${color})` },
    'Quin':   { code: `DHQN-${c}`,  series: `Quin Double Hung (${color})` },
    'Q/H/Q':  { code: `DHQHQ-${c}`, series: `Q/H/Q Double Hung (${color})` },
  };
  return codes[config] || codes['Single'];
}

// HS — Horizontal Slider
function hsCode(config, color) {
  const c = COLOR_SUFFIX[color] || 'WH';
  const codes = {
    'Single': { code: `HS-${c}`,   series: `Horizontal Slider (${color})` },
    'Twin':   { code: `HST-${c}`,  series: `Twin Horizontal Slider (${color})` },
    'Triple': { code: `HSTR-${c}`, series: `Triple Horizontal Slider (${color})` },
    'Quad':   { code: `HSQ-${c}`,  series: `Quad Horizontal Slider (${color})` },
    'Quin':   { code: `HSQN-${c}`, series: `Quin Horizontal Slider (${color})` },
  };
  return codes[config] || codes['Single'];
}

// CSMT — Casement
// Handing values from the UI:
//   'Hinge Left'   → Left Hinged
//   'Hinge Right'  → Right Hinged
//   'Fixed Unit'   → Fixed (no hinge — picture-style casement frame)
//   'Awning'       → Awning (top-hinged casement — shown standalone as "Awning")
//   anything else  → treated as Left Hinged (safe fallback)
function csmtCode(config, handing, color) {
  const c = COLOR_SUFFIX[color] || 'WH';

  // Single casement — handing determines code
  if (config === 'Single') {
    // Normalise: trim and lowercase so casing differences never cause a miss
    const h = (handing || '').trim().toLowerCase();

    if (h === 'awning') {
      // Awning — top-hinged casement. Shown standalone as "Awning (Color)",
      // never "Casement", per shop preference. Same cut formulas as casement.
      return { code: `SGCMA-${c}`, series: `Awning (${color})` };
    }
    if (h === 'fixed unit' || h === 'fixed') {
      return { code: `SGCMF-${c}`, series: `Single Fixed Casement (${color})` };
    }
    if (h === 'hinge right') {
      return { code: `SGCMR-${c}`, series: `Single Right Hinged Casement (${color})` };
    }
    // 'Hinge Left' or any unrecognised value → Left Hinged
    return { code: `SGCML-${c}`, series: `Single Left Hinged Casement (${color})` };
  }

  // Multi-lite casements — handing does not apply
  const codes = {
    '2-Lite': { code: `PWCM-${c}`,  series: `Picture Window Casement (${color})` },
    '3-Lite': { code: `3LTCM-${c}`, series: `3-Lite Casement (${color})` },
    '4-Lite': { code: `4LTCM-${c}`, series: `4-Lite Casement (${color})` },
    '5-Lite': { code: `5LTCM-${c}`, series: `5-Lite Casement (${color})` },
  };
  return codes[config] || { code: `SGCML-${c}`, series: `Single Left Hinged Casement (${color})` };
}

// PW — Picture Window
function pwCode(color) {
  const c = COLOR_SUFFIX[color] || 'WH';
  return { code: `PW-${c}`, series: `Picture Window (${color})` };
}

// BSMT — Basement Hopper
function bsmtCode(color) {
  const c = COLOR_SUFFIX[color] || 'WH';
  return { code: `BSMT-${c}`, series: `Basement Hopper (${color})` };
}

// 3HS — 3-Lite Horizontal Slider
function threeHSCode(color) {
  const c = COLOR_SUFFIX[color] || 'WH';
  return { code: `3HS-${c}`, series: `3-Lite Horizontal Slider (${color})` };
}

// BM — Brickmould
function bmCode(color) {
  const c = COLOR_SUFFIX[color] || 'WH';
  return { code: `BM-${c}`, series: `Brickmould (${color})` };
}

export function getInventoryCode(window) {
  const { type, config, handing, color } = window;
  switch (type) {
    case 'DH':   return dhCode(config, color);
    case 'HS':   return hsCode(config, color);
    case 'CSMT': return csmtCode(config, handing, color);
    case 'PW':   return pwCode(color);
    case 'BSMT': return bsmtCode(color);
    case '3HS':  return threeHSCode(color);
    case 'BM':   return bmCode(color);
    default:     return { code: `UNK-${color}`, series: `Unknown (${color})` };
  }
}